"use client";

import { Car, Clock, MapPin, TrainFront as Train, Wine } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurTrainingGrounds() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const mapReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const tilesReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const infoTiles = [{
    icon: Car,
    label: "PARKING",
    desc: "Private lot available on-site"
  }, {
    icon: Train,
    label: "TRANSIT",
    desc: "Central Station, 5 min walk"
  }, {
    icon: Wine,
    label: "ASSESSMENT",
    desc: "By appointment only"
  }, {
    icon: Clock,
    label: "HOURS",
    desc: "Mon-Sat, 06:00-22:00"
  }];
  return <section data-section-id="4943" id="our-training-grounds" className="bg-background text-foreground pt-20 pb-40 overflow-hidden">
      {}
      <div ref={header.ref} className={`px-6 md:px-12 lg:px-16 mb-12 md:mb-16 transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="flex items-center gap-3 mb-6">
          <span className="inline-block w-2 h-2" style={{
          backgroundColor: "var(--primary)"
        }} aria-hidden="true" />
          <span className="font-default text-xs md:text-sm font-medium tracking-[0.25em] uppercase" style={{
          color: "var(--primary)"
        }}>
            TRAINING FACILITY
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-end">
          <h2 className="lg:col-span-8 font-default font-bold uppercase text-4xl sm:text-5xl md:text-6xl lg:text-[4rem] leading-[0.95] tracking-tighter text-foreground">
            LOCATE THE
            <br />
            <span className="italic text-primary">FORCE.</span>
          </h2>
          <p className="lg:col-span-4 font-default text-base md:text-lg text-muted-foreground leading-relaxed">
            Engineered for peak performance. Located in the heart of the city.
          </p>
        </div>
      </div>

      {}
      <div ref={mapReveal.ref} className={`px-6 md:px-12 lg:px-[120px] transition-all duration-1000 ease-out ${mapReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="relative w-full" style={{
        boxShadow: "var(--shadow-lg)"
      }}>
          {}
          <div className="relative w-full h-[500px] md:h-[600px] overflow-hidden border border-border" style={{
          backgroundColor: "var(--card)"
        }}>
            {}
            <svg viewBox="0 0 1200 600" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full" aria-hidden="true">
              {}
              <rect width="1200" height="600" fill="var(--background)" />
              <path d="M0 380 Q 180 360 320 400 T 620 420 L 620 600 L 0 600 Z" fill="var(--card)" />
              <path d="M880 0 L 1200 0 L 1200 180 Q 1040 200 920 160 Z" fill="var(--card)" />

              {}
              <g stroke="var(--border)" strokeWidth="2" fill="none">
                <path d="M0 300 L 1200 300" />
                <path d="M600 0 L 600 600" />
                <path d="M0 120 L 1200 180" />
                <path d="M0 480 L 1200 460" />
                <path d="M300 0 L 380 600" />
                <path d="M820 0 L 760 600" />
                <path d="M0 60 L 600 280" />
                <path d="M600 280 L 1200 540" />
              </g>

              {}
              <g stroke="var(--muted)" strokeWidth="1" fill="none">
                <path d="M0 200 L 1200 220" />
                <path d="M0 400 L 1200 400" />
                <path d="M150 0 L 200 600" />
                <path d="M450 0 L 480 600" />
                <path d="M700 0 L 680 600" />
                <path d="M950 0 L 980 600" />
                <path d="M0 250 L 1200 250" />
                <path d="M0 350 L 1200 350" />
                <path d="M0 150 L 1200 150" />
                <path d="M0 520 L 1200 520" />
              </g>

              {}
              <g fill="var(--muted)" opacity="0.6">
                <rect x="40" y="40" width="80" height="60" />
                <rect x="200" y="180" width="100" height="50" />
                <rect x="380" y="60" width="60" height="80" />
                <rect x="500" y="200" width="80" height="60" />
                <rect x="700" y="40" width="100" height="70" />
                <rect x="850" y="200" width="70" height="60" />
                <rect x="1000" y="60" width="90" height="80" />
                <rect x="40" y="540" width="120" height="40" />
                <rect x="240" y="500" width="80" height="60" />
                <rect x="440" y="540" width="90" height="40" />
                <rect x="780" y="540" width="100" height="40" />
                <rect x="1020" y="500" width="80" height="60" />
              </g>

              {}
              <g fill="var(--muted-foreground)" fontSize="9" fontFamily="var(--font-mono)" letterSpacing="2">
                <text x="40" y="295">MAIN STREET</text>
                <text x="610" y="115" transform="rotate(2 610 115)">POWER AVE</text>
                <text x="40" y="475">FITNESS BLVD</text>
                <text x="615" y="20" transform="rotate(90 615 20)">STRENGTH WAY</text>
              </g>
            </svg>

            {}
            <div className="absolute" style={{
            top: "48%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }}>
              <div className="relative">
                {}
                <span className="absolute inset-0 -m-4 block animate-ping" style={{
                border: "2px solid var(--primary)",
                animationDuration: "3s"
              }} aria-hidden="true" />
                <span className="absolute inset-0 -m-2 block animate-ping" style={{
                border: "1px solid var(--primary)",
                animationDuration: "3s",
                animationDelay: "0.5s"
              }} aria-hidden="true" />
                {}
                <span className="relative block w-4 h-4" style={{
                backgroundColor: "var(--primary)",
                boxShadow: "0 0 24px var(--primary)"
              }} aria-hidden="true" />
              </div>
            </div>

            {}
            <div className="absolute backdrop-blur-xl border p-6 md:p-7 max-w-[280px] md:max-w-[320px]" style={{
            top: "48%",
            left: "calc(50% + 32px)",
            backgroundColor: "var(--card)",
            borderColor: "var(--primary)",
            boxShadow: "var(--shadow-xl)"
          }}>
              <div className="flex items-center gap-2 mb-3">
                <MapPin className="w-3.5 h-3.5" style={{
                color: "var(--primary)"
              }} strokeWidth={2} />
                <span className="font-default font-bold text-xs tracking-[0.2em] uppercase" style={{
                color: "var(--primary)"
              }}>
                  HQ
                </span>
              </div>
              <h3 className="font-default font-bold uppercase text-xl md:text-2xl tracking-tight text-foreground mb-3 leading-none">
                PEAK FORCE
              </h3>
              <p className="font-default text-sm text-foreground/85 leading-relaxed mb-4">
                100 Fitness Plaza
                <br />
                City Center, State 00000
              </p>
              <div className="font-default text-xs leading-relaxed mb-5" style={{
              color: "var(--muted-foreground)"
            }}>
                TRAINING ZONE
                <br />
                MON&ndash;SAT &middot; 06:00&ndash;22:00
                <br />
                BY APPOINTMENT
              </div>
              <Link to="https://maps.google.com" newTab className="inline-flex items-center gap-2 font-default font-semibold text-xs tracking-[0.2em] uppercase transition-opacity hover:opacity-70" style={{
              color: "var(--primary)"
            }}>
                GET DIRECTIONS
                <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>

            {}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: "radial-gradient(ellipse at center, transparent 40%, var(--background) 100%)"
          }} aria-hidden="true" />
          </div>
        </div>
      </div>

      {}
      <div ref={tilesReveal.ref} className={`px-6 md:px-12 lg:px-[120px] mt-16 md:mt-20 transition-all duration-700 ease-out ${tilesReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-b" style={{
        borderColor: "var(--border)"
      }}>
          {infoTiles.map((tile, i) => {
          const Icon = tile.icon;
          return <div data-index={i} key={tile.label} className="relative p-6 md:p-8 group" style={{
            borderRight: i < infoTiles.length - 1 ? "1px solid var(--border)" : undefined
          }}>
                <div className="flex items-start gap-4">
                  <div className="shrink-0 mt-1">
                    <Icon className="w-5 h-5" style={{
                  color: "var(--primary)"
                }} strokeWidth={1.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-default font-bold text-xs tracking-[0.25em] uppercase mb-2" style={{
                  color: "var(--primary)"
                }}>
                      {tile.label}
                    </div>
                    <p className="font-default text-sm text-foreground/85 leading-snug">
                      {tile.desc}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {}
        <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="font-default text-sm italic" style={{
          color: "var(--muted-foreground)"
        }}>
            Engineered for those who demand more from their bodies.
          </p>
          <Link to="/JoinTheForcePage">
            <Button variant="outline" size="lg" className="font-default font-semibold text-xs tracking-[0.25em] uppercase bg-transparent border-primary text-primary hover:bg-primary hover:text-background">
              START YOUR JOURNEY
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}